// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import React from 'react'
import { number } from 'prop-types'

const CompaniesHeader = ({ companyCount }) => (
  <strong className={'underline display-block margin-top-1'}>
    {
      companyCount === 1
        ? 'Associated Company'
        : `${companyCount} Associated Companies`
    }
  </strong>
)

CompaniesHeader.propTypes = {
  companyCount: number.isRequired,
}

export default CompaniesHeader
